import { useEffect, useState } from "react";
import { setPage } from "../store/userSlice";
import { DiOpensource } from "react-icons/di";
import { CgMoveLeft, CgNotes } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import {
  BiHomeSmile,
  BiBookmarkAltPlus,
  BiMoney,
  BiLogOutCircle,
} from "react-icons/bi";
import hr_text_white from "../assets/branding/hr-text-white1.png";
import { IoNewspaperOutline, IoWalletOutline } from "react-icons/io5";
import {
  AiTwotoneFlag,
  AiOutlineProject,
  AiOutlineStock,
} from "react-icons/ai";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
import { TbReportAnalytics, TbUserCircle } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";
import { FaWpforms } from "react-icons/fa";
import { GiAirplaneArrival, GiMoneyStack, GiTeacher } from "react-icons/gi";
import { SlOrganization } from "react-icons/sl";
import { TfiControlBackward } from "react-icons/tfi";
import { HiOutlineDocumentText } from "react-icons/hi2";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import {
  BsCheckSquare,
  BsBuildingFillAdd,
  BsFillSignIntersectionSideFill,
} from "react-icons/bs";

export default function SideBar({ navbarOpen, setNavbarOpen, blockData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const loaderData = useLoaderData();

  const { dashboardPage } = useSelector((state) => state.user);
  const dashboardData = useSelector((state) => state.dashboardData);
  let user = {},
    user_detail = {},
    imageUrl;
  if (!blockData) {
    user = dashboardData?.data?.user;
    user_detail = user?.user_detail;
    imageUrl = user_detail?.profile_image_path;
  }

  const checkAccess = (module, name) => {
    if (
      dashboardData?.data?.user_permissions.find(
        (object) =>
          object.name?.trim() === name?.trim() &&
          object.module?.trim() === module?.trim()
      )
    ) {
      if (
        dashboardData?.data?.permissions.find(
          (object) =>
            object.name?.trim() === name?.trim() &&
            object.module?.trim() === module?.trim()
        )
      ) {
        return true;
      }
    }
  };

  useEffect(() => {
    setNavbarOpen(false);
  }, [dashboardPage]);

  const handleGoBack = () => {
    let basePath = location.pathname.split("/").slice(0, -1);
    if (basePath.at(-1) === "edit" && basePath.at(-2) !== "job-enquiry") {
      basePath = basePath.slice(0, -1);
    }
    basePath = basePath.join("/");
    navigate(basePath);
  };
  return (
    <div
      className={`sidebar top-16 sm:top-auto ${
        navbarOpen ? "w-full" : "w-0"
      }  sm:w-full z-10 absolute sm:max-w-xs sm:block sm:fixed  sm:z-auto transition-all  ease-in-out overflow-hidden bg-blue dark:bg-dark2  `}
    >
      <div className="bg-indigo dark:bg-dark text-white w-full sm:flex justify-between items-center p-2 hidden">
        <img src={hr_text_white} alt="logo" width={100} />
        <TfiControlBackward
          size={"1.3rem"}
          className="mr-4 cursor-pointer"
          onClick={() => handleGoBack()}
        />
        <CgMoveLeft
          size={"1.5rem"}
          className="mr-4 sm:pointer-events-none sm:hidden"
          onClick={() => setNavbarOpen((p) => !p)}
        />
      </div>
      <div
        className="flex gap-3 items-center sm:hidden text-sm text-white p-4 "
        onClick={() => dispatch(setPage("Edit Profile"))}
      >
        <img src={imageUrl} alt="user" className="w-7 h-7 rounded-full" />
        <div>
          <p>{user?.name}</p>
          <p className="text-gray">{user?.email}</p>
        </div>
      </div>
      <div className=" sm:min-h-screen min-h-auto sm:h-auto h-[83.2vh]  sm:pb-20  relative   bg-blue dark:bg-dark2 w-full p-4 sm:pt-6 ">
        <div className="sm:h-[78vh] h-[73vh]  overflow-y-auto pr-2">
          <div className="  text-white  text-sm  flex flex-col gap-1 items-center ">
            <SideBarItem title="Dashboard" Icon={BiHomeSmile}></SideBarItem>
            {(checkAccess("Quotation", "quotation-list") ||
              checkAccess("Contract", "contract-list") ||
              checkAccess("Project", "project-list") ||
              checkAccess("ARRIVAL / ONBOARDING", "arrival-onboarding-view") ||
              checkAccess(
                "OPS1 MASTER DATABASE",
                "ops1-master-database-view"
              )) && (
              <SideBarItem
                title="OPS 1 WORKFLOW"
                Icon={BiBookmarkAltPlus}
                isChildren
                childTitle={["Quotation", "Contract", "Project"]}
              >
                {checkAccess("Quotation", "quotation-list") && (
                  <SideBarItem
                    title="Quotation"
                    parentTitle="OPS 1 WORKFLOW"
                    Icon={BiBookmarkAltPlus}
                    child
                  />
                )}
                {checkAccess("Contract", "contract-list") && (
                  <SideBarItem
                    title="Contract"
                    parentTitle="OPS 1 WORKFLOW"
                    Icon={HiOutlineDocumentText}
                    child
                  />
                )}
                {checkAccess("Project", "project-list") && (
                  <SideBarItem
                    title="Project"
                    Icon={AiOutlineProject}
                    showTitle="Project"
                    parentTitle="OPS 1 WORKFLOW"
                    child
                  />
                )}
                {checkAccess(
                  "ARRIVAL / ONBOARDING",
                  "arrival-onboarding-view"
                ) && (
                  <SideBarItem
                    title="Arrival onboarding"
                    Icon={AiOutlineProject}
                    showTitle="ARRIVAL/ONBOARDING"
                    parentTitle="OPS 1 WORKFLOW"
                    child
                  />
                )}
                {checkAccess(
                  "OPS1 MASTER DATABASE",
                  "ops1-master-database-view"
                ) && (
                  <SideBarItem
                    title="Ops 1 Master Database"
                    Icon={AiOutlineProject}
                    showTitle="Ops 1 Master Database"
                    parentTitle="OPS 1 WORKFLOW"
                    child
                  />
                )}
              </SideBarItem>
            )}
            {(checkAccess("VISA REQUEST FORM", "visa-request-form-view") ||
              checkAccess(
                "VISA ALLOCATION / REVERSE",
                "visa-allocation-reverse-view"
              ) ||
              checkAccess("VISA RETURN REQUEST", "visa-return-request-view") ||
              checkAccess("VISA STOCK", "visa-stock-view")) && (
              <SideBarItem
                title="VISA"
                Icon={BiBookmarkAltPlus}
                isChildren
                childTitle={[
                  "Visa Request Form",
                  "Visa Allocation/Reverse",
                  "Visa return request",
                  "Visa Stock",
                ]}
              >
                {checkAccess("VISA REQUEST FORM", "visa-request-form-view") && (
                  <SideBarItem
                    title="Visa Request Form"
                    parentTitle="VISA"
                    Icon={BiBookmarkAltPlus}
                    child
                  />
                )}
                {/* <SideBarItem
                title="VisaAllocation/Reverse"
                parentTitle="VISA"
                Icon={HiOutlineDocumentText}
                child
              /> */}
                {checkAccess(
                  "VISA ALLOCATION / REVERSE",
                  "visa-allocation-reverse-view"
                ) && (
                  <SideBarItem
                    title="Visa Allocation"
                    parentTitle="VISA"
                    showTitle="Visa Allocation/Reverse"
                    Icon={HiOutlineDocumentText}
                    child
                  />
                )}

                {checkAccess(
                  "VISA RETURN REQUEST",
                  "visa-return-request-view"
                ) && (
                  <SideBarItem
                    title="Visa return request"
                    Icon={AiOutlineProject}
                    showTitle="Visa return request"
                    parentTitle="VISA"
                    child
                  />
                )}
                {checkAccess("VISA STOCK", "visa-stock-view") && (
                  <SideBarItem
                    title="Visa Stock"
                    Icon={AiOutlineProject}
                    showTitle="Visa Stock"
                    parentTitle="VISA"
                    child
                  />
                )}
              </SideBarItem>
            )}
            <SideBarItem
              title="FINANCE DESK"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={[
                "Visa cost & sec deposit",
                "Vrf/vrr payment",
                "Loan/Advance",
                "YTC",
                "Dependent Payment",
              ]}
            >
              <SideBarItem
                title="Visa cost & sec deposit"
                parentTitle="FINANCE DESK"
                Icon={BiBookmarkAltPlus}
                child
              />
              <SideBarItem
                title="vrr payment"
                parentTitle="FINANCE DESK"
                showTitle="Vrf/vrr payment"
                Icon={HiOutlineDocumentText}
                child
              />
              <SideBarItem
                title="loan advance"
                Icon={AiOutlineProject}
                showTitle="Loan/Advance"
                parentTitle="FINANCE DESK"
                child
              />
              <SideBarItem
                title="INVOICE-COST PLUS"
                Icon={AiOutlineProject}
                showTitle="INVOICE-COST PLUS"
                parentTitle="FINANCE DESK"
                child
              />
              <SideBarItem
                title="Dependent Payment"
                Icon={AiOutlineProject}
                showTitle="Dependent Payment"
                parentTitle="FINANCE DESK"
                child
              />
            </SideBarItem>

            {(checkAccess("Client", "client-list") ||
              checkAccess("Nationality", "nationality-list") ||
              checkAccess("Rate Category", "rate-category-list") ||
              checkAccess("Company", "company-list") ||
              checkAccess("VISA STOCK", "visa-stock-view") ||
              checkAccess(
                "VISA / IQAMA PROFESSION",
                "visa-iqama-profession-view"
              ) ||
              checkAccess("PROFESSION LEVELS", "profession-levels-view") ||
              checkAccess("INSURANCE COMPANY", "insurance-company-view") ||
              checkAccess("Job Position", "job-position-list") ||
              checkAccess("Source", "source-list") ||
              checkAccess("Sector", "sector-list") ||
              checkAccess("Vendor", "vendor-list") ||
              checkAccess("Notes", "note-list") ||
              checkAccess(
                "Terms And Condition",
                "terms-and-conditions-list"
              )) && (
              <SideBarItem
                title="MASTER TABLES"
                Icon={BiBookmarkAltPlus}
                isChildren
                childTitle={[
                  "Client",
                  "Service Charge Edit",
                  "Passport Renewal",
                  "Visa Providers",
                  "Recruitment Agency",
                  "Actual Profession",
                  "Visa Profession",
                  "PROFESSION LEVELS & FEES",
                  "Rate Category",
                  "Insurance Company",
                  "Nationality",
                  "Sector",
                  "Source",
                  "Visa Stock",
                  "Visa Report",
                  "Job Position",
                  "Notes",
                  "Terms and Condition",
                  "Templates",
                  "Finance",
                  "Users",
                  "Roles And Permission",
                ]}
              >
                {checkAccess("Client", "client-list") ? (
                  <SideBarItem
                    title="Client"
                    Icon={FiUsers}
                    child
                    parentTitle="MASTER TABLES "
                  />
                ) : (
                  ""
                )}

                {/* {checkAccess("Company", "company-list") && (
                  <SideBarItem
                    title="Passport Renewal"
                    showTitle="Passport Renewal"
                    Icon={BsBuildingFillAdd}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )} */}

                {checkAccess("Vendor", "vendor-list") && (
                  <SideBarItem
                    title="Recruitment Agency"
                    Icon={HiOutlineUserGroup}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                {checkAccess("Job Position", "job-position-list") ? (
                  <SideBarItem
                    title="Actual Profession"
                    Icon={GiTeacher}
                    child
                    parentTitle="MASTER TABLES"
                  />
                ) : (
                  ""
                )}

                {checkAccess(
                  "VISA / IQAMA PROFESSION",
                  "visa-iqama-profession-view"
                ) ? (
                  <SideBarItem
                    title="Visa Profession"
                    showTitle="Visa / IQAMA Profession"
                    Icon={SlOrganization}
                    child
                    parentTitle="MASTER TABLES"
                  />
                ) : (
                  ""
                )}
                {checkAccess("Company", "company-list") && (
                  <SideBarItem
                    title="Visa Providers"
                    showTitle="Visa Provider"
                    Icon={SlOrganization}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                {checkAccess("PROFESSION LEVELS", "profession-levels-view") && (
                  <SideBarItem
                    title="PROFESSION LEVELS & FEES"
                    Icon={HiOutlineUserGroup}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}

                {checkAccess("Rate Category", "rate-category-list") && (
                  <SideBarItem
                    title="Rate Category"
                    Icon={IoWalletOutline}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                {checkAccess("INSURANCE COMPANY", "insurance-company-view") && (
                  <SideBarItem
                    title="Insurance Company"
                    Icon={IoWalletOutline}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                {checkAccess("VISA STOCK", "visa-stock-view") && (
                  <SideBarItem
                    title="Visa Stock"
                    Icon={AiOutlineProject}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}

                {checkAccess("Nationality", "nationality-list") ? (
                  <SideBarItem
                    title="Nationality"
                    Icon={AiTwotoneFlag}
                    child
                    parentTitle="MASTER TABLES"
                  />
                ) : (
                  ""
                )}
                {checkAccess("Sector", "sector-list") && (
                  <SideBarItem
                    title="Sector"
                    Icon={BsFillSignIntersectionSideFill}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                {checkAccess("Source", "source-list") && (
                  <SideBarItem
                    title="Source"
                    Icon={DiOpensource}
                    child
                    parentTitle="MASTER TABLES"
                  />
                )}
                <div className="  text-white text-sm  flex flex-col gap-1 items-center ">
                  {checkAccess("User", "user-list") && (
                    <SideBarItem title="Users" Icon={TbUserCircle} />
                  )}
                  {checkAccess("Roles and Permissions", "role-list") && (
                    <SideBarItem
                      title="Roles And Permission"
                      Icon={BsCheckSquare}
                    />
                  )}
                </div>

                {/* {checkAccess("Visa", "visa-profession-list") ? (
                <SideBarItem
                  title="Visa Report"
                  Icon={TbReportAnalytics}
                  child
                  parentTitle="MASTER TABLES"
                />
              ) : (
                ""
              )} */}

                {/* <SideBarItem
                title="GR"
                Icon={GiTeacher}
                isChildren
                childTitle={["VRF"]}
                parentTitle="MASTER TABLES"
              >
                <SideBarItem
                  title="GR-VRF"
                  Icon={DiOpensource}
                  child
                  parentTitle="GR"
                />
              </SideBarItem> */}

                {/* {checkAccess("Notes", "note-list") && (
                <SideBarItem
                  title="Notes"
                  Icon={CgNotes}
                  child
                  parentTitle="MASTER TABLES"
                />
              )} */}

                {/* {checkAccess(
                "Terms And Condition",
                "terms-and-conditions-list"
              ) && (
                <SideBarItem
                  title="Terms and Condition"
                  Icon={IoNewspaperOutline}
                  child
                  parentTitle="MASTER TABLES"
                />
              )} */}
                {/* <SideBarItem
                title="Finance"
                Icon={BiMoney}
                isChildren
                childTitle={["VRF", "Payments"]}
                parentTitle="MASTER TABLES"
              >
                <SideBarItem
                  title="Vrf"
                  parentRoute="finance"
                  Icon={FaWpforms}
                  child
                  parentTitle="Finance"
                />
                <SideBarItem
                  title="Payments"
                  parentRoute="finance"
                  Icon={GiMoneyStack}
                  child
                  parentTitle="Finance"
                />
              </SideBarItem> */}
                </SideBarItem>
              )}
            <SideBarItem title="OPS 2 Master Database" Icon={BiHomeSmile}>
            </SideBarItem>
            <SideBarItem
              title="Ops 2 Workflow"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={[
                "ServiceChargeEdit",
                "Border Number",
                "On Arrival Medical",
                "Insurance",
                "Sadaad",
                "Iqama",
                "Absher",
                "Atm Payroll",
                "Ajeer",
                "Baladiya",
                "Driving Licence",
                "Visa Profession Changes",
                "Nakal Kafala",
                "Passport Renewal",
                "QIWA CONTRACT OPS",
                "Service Charge Edit",
              ]}
            >
              {checkAccess("SERVICE CHARGE EDIT", "service-charge-edit-view") ? (
                <SideBarItem
                  title="Service Charge Edit"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              ) : (
                ""
              )}
              {checkAccess("BORDER NUMBER", "border-number-view") ? (
                <SideBarItem
                  title="Border Number"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              ) : (
                ""
              )}

              {checkAccess("ON ARRIVAL MEDICAL", "on-arrival-medical-view") ? (
                <SideBarItem
                  title="On Arrival Medical"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 Master Database"
                />
              ) : (
                ""
              )}

              {checkAccess("INSURANCE", "insurance-view") && (
                <SideBarItem
                  title="Insurance"
                  showTitle="Insurance"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("SADAAD", "sadad-view") && (
                <SideBarItem
                  title="Sadaad"
                  showTitle="Sadaad"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("IQAMA", "iqama-update-list-view") && (
                <SideBarItem
                  title="Iqama"
                  showTitle="Iqama"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("ABSHER", "absher-view") && (
                <SideBarItem
                  title="Absher"
                  showTitle="Absher"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("ATM / PAYROLL", "atm-payroll-view") && (
                <SideBarItem
                  title="Atm Payroll"
                  showTitle="Atm/Payroll"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("AJEER", "ajeer-update-view") && (
                <SideBarItem
                  title="Ajeer"
                  showTitle="Ajeer"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("BALADIYA", "baladiya-update-view") && (
                <SideBarItem
                  title="Baladiya"
                  showTitle="Baladiya"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("DRIVING LICENSE", "driving-license-update-view") && (
                <SideBarItem
                  title="Driving Licence"
                  showTitle="Driving Licence"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}
              {checkAccess("VISA PROFESSION CHANGE", "visa-profession-change-view") && (
                <SideBarItem
                  title="Visa Profession Changes"
                  showTitle="Visa Profession Changes"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("NAKAL KAFALA", "nakal-kafala-view") && (
                <SideBarItem
                  title="Nakal Kafala"
                  showTitle="Nakal Kafala"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}
               {checkAccess("QIWA CONTRACT", "qiwa-contract-view") && (
                <SideBarItem
                  title="QIWA CONTRACT OPS"
                  showTitle="QIWA CONTRACT"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}

              {checkAccess("PASSPORT RENEWAL", "passport-renewal-view") && (
                <SideBarItem
                  title="Passport Renewal"
                  showTitle="Passport Renewal"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Ops 2 Workflow"
                />
              )}
            </SideBarItem>

            {/* Finance Side manu */}
            <SideBarItem
              title="Finance"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={[
                "Fin Insurance",
                "Fin On Arrival Medical",
                "Fin Sadaad",
                "Fin Atm PayRoll",
                "Fin PayRoll Category",
                "Fin Ajeer",
                "Fin Baladiya",
                "Fin Driving Licence",
                "Fin Visa Profession Changes",
                "Fin Nakal Kafala",
                "Fin PassPort Renewal",
              ]}
            >
              {checkAccess("FINANCE DEMOBILIZATION", "ere-emergency-view") || checkAccess("FINANCE DEMOBILIZATION", "ere-annual-vacation-view") ? (
                <SideBarItem
                  title="Fin On Arrival Medical"
                  showTitle={"On Arrival Medical"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Finance"
                />
              ) : (
                ""
              )}

              {checkAccess("INSURANCE", "insurance-view") && (
                <SideBarItem
                  title="Fin Insurance"
                  showTitle="Insurance"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Finance"
                />
              )}
              {checkAccess("SADAAD", "sadad-view") && (
                <SideBarItem
                  title="Fin Sadaad"
                  showTitle="Sadaad"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("ATM / PAYROLL", "atm-payroll-view") && (
                <SideBarItem
                  title="Fin Atm Payroll"
                  showTitle="ATM/PAYROLL"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("ATM / PAYROLL", "atm-payroll-view") && (
                <SideBarItem
                  title="Fin Payroll Category"
                  showTitle="PayRoll Category"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("AJEER", "ajeer-update-view") && (
                <SideBarItem
                  title="Fin Ajeer"
                  showTitle="AJEER"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("BALADIYA", "baladiya-update-view") && (
                <SideBarItem
                  title="Fin Baladiya"
                  showTitle="BALADIYA"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("DRIVING LICENSE", "driving-license-update-view") && (
                <SideBarItem
                  title="Fin Driving Licence"
                  showTitle="Driving Licence"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("VISA PROFESSION CHANGE", "visa-profession-change-view") && (
                <SideBarItem
                  title="Fin Visa Profession Changes"
                  showTitle="VISA PROFESSION CHANGES"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("NAKAL KAFALA", "nakal-kafala-view") && (
                <SideBarItem
                  title="Fin Nakal Kafala"
                  showTitle="Nakal Kafala"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}

              {checkAccess("PASSPORT RENEWAL", "passport-renewal-view") && (
                <SideBarItem
                  title="Fin Passport Renewal"
                  showTitle="PassPort Renewal"
                  Icon={BsBuildingFillAdd}
                  child
                  parentTitle="Finance"
                />
              )}
            </SideBarItem>
            <SideBarItem
              title="GR TEAM"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={["QIWA CONTRACT", "GR AJEER"]}
            >
              {checkAccess("QIWA CONTRACT", "qiwa-contract-view") ? (
                <SideBarItem
                  title="QIWA CONTRACT"
                  showTitle={"QIWA CONTRACT"}
                  Icon={FiUsers}
                  child
                  parentTitle="GR TEAM"
                />
              ) : (
                ""
              )}

              {checkAccess("AJEER", "ajeer-update-view") ? (
                <SideBarItem
                  showTitle={"AJEER"}
                  title="GR AJEER"
                  Icon={FiUsers}
                  child
                  parentTitle="GR TEAM"
                />
              ) : (
                ""
              )}
            </SideBarItem>
            <SideBarItem
              title="File Manager"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={["Candidates"]}
            >
              {checkAccess("Client", "client-list") ? (
                <SideBarItem
                  title="Candidates"
                  Icon={FiUsers}
                  child
                  parentTitle="File Manager"
                />
              ) : (
                ""
              )}
            </SideBarItem>

            <SideBarItem
              title="Ops 2 WORKFLOW"
              Icon={BiBookmarkAltPlus}
              isChildren
              childTitle={[
                "DependentMaster",
                "InsuranceDependent",
                "DependentAddition",
                "MOBILIZATION",
                "DEMOBILIZATION",
                "REMOBILIZATION",
                "FINAL EXIT",
                "Settlement Preview",
                "FINANCE-DEMOBILIZATION",
              ]}
            >
                {checkAccess("DEPENDENT MASTER", "dependent-master-view") && (
                <SideBarItem
                  title="Dependent Master"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
                )}

                {checkAccess("DEPENDENT ADDITION", "dependent-addition-view") && (
                <SideBarItem
                  title="Dependent Addition"
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
                )}

              {checkAccess("MOBILIZATION", "mobilization-view") ? (
                <SideBarItem
                  title="MOBILIZATION"
                  showTitle={"MOBILIZATION"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
              {checkAccess("DEMOBILIZATION", "active-view") ? (
                <SideBarItem
                  title="DEMOBILIZATION"
                  showTitle={"DEMOBILIZATION"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
              {checkAccess("REMOBILIZAITON", "remobilizaiton-view") ? (
                <SideBarItem
                  title="REMOBILIZATION"
                  showTitle={"REMOBILIZATION"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
              {checkAccess("FINAL EXIT", "final-exit-queue-view") ? (
                <SideBarItem
                  title="FINAL EXIT"
                  showTitle={"FINAL EXIT"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
              {checkAccess("Client", "client-list") ? (
                <SideBarItem
                  title="Settlement Preview"
                  showTitle={"Settlement Preview"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
              {checkAccess("FINANCE DEMOBILIZATION", "ere-emergency-view") ? (
                <SideBarItem
                  title="FINANCE-DEMOBILIZATION"
                  showTitle={"FINANCE-DEMOBILIZATION"}
                  Icon={BiBookmarkAltPlus}
                  child
                  parentTitle="Ops 2 WORKFLOW"
                />
              ) : (
                ""
              )}
            </SideBarItem>
          </div>
        </div>

        <div
          className=" sm:mt-5 mt-0 p-2 w-full font-medium cursor-pointer text-white bg-red rounded-lg  dark:bg-dark2 dark:hover:bg-red flex items-center gap-3"
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("nodeToken");
            navigate("/login");
          }}
        >
          <BiLogOutCircle /> Logout
        </div>
        {/* {(checkAccess("User", "user-list") ||
          checkAccess("Roles and Permissions", "role-list")) && (
          <p className="text-gray text-xs mt-6 mb-4">USER</p>
        )} */}
        {/* <div className="  text-white text-sm  flex flex-col gap-1 items-center ">
          {checkAccess("User", "user-list") && (
            <SideBarItem title="Users" Icon={TbUserCircle} />
          )}
          {checkAccess("Roles and Permissions", "role-list") && (
            <SideBarItem title="Roles And Permission" Icon={BsCheckSquare} />
          )}
          <SideBarItem title="Arrival Notification" Icon={GiAirplaneArrival} />
        </div> */}
        {/* <SideBarItem title="Dummy Pdfs" Icon={GiAirplaneArrival} /> */}
      </div>
    </div>
  );
}

const SideBarItem = ({
  title,
  showTitle,
  Icon,
  children,
  child,
  isChildren,
  parentRoute,
}) => {
  const dispatch = useDispatch();
  const { dashboardPage } = useSelector((state) => state.user);

  const [dropDownOpen, setDropDownOpen] = useState(false);
  function clickSideBarItem(title, child) {
    if (!isChildren) dispatch(setPage(title));
    if (!child) setDropDownOpen((p) => !p);
  }

  return (
    <>
      {isChildren ? (
        <div
          onClick={() => clickSideBarItem(title, child, dropDownOpen)}
          className={`${
            String(dashboardPage).toLowerCase() ===
              String(title).toLowerCase() && "bg-red"
          } transition-all ease-in-out rounded-md w-full  cursor-pointer flex items-center gap-2 p-2  justify-between hover:bg-red`}
        >
          <div className="flex gap-2 items-center ">
            <Icon />{" "}
            {showTitle ? showTitle.toUpperCase() : title?.toUpperCase()}
          </div>
          {isChildren &&
            (dropDownOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />)}
        </div>
      ) : (
        <Link
          className="w-full"
          to={
            title === "Dashboard"
              ? `/dashboard`
              : `/dashboard/${parentRoute ? parentRoute + "/" : ""}${String(
                  title
                )
                  .toLowerCase()
                  .split(" ")
                  .join("-")}`
          }
        >
          <div
            onClick={() => clickSideBarItem(title, child, dropDownOpen)}
            className={`${
              dashboardPage === title && "bg-red"
            } transition-all ease-in-out rounded-md w-full  cursor-pointer flex items-center gap-2 p-2  justify-between hover:bg-red`}
          >
            <div className="flex gap-2 items-center ">
              {" "}
              <Icon />{" "}
              {showTitle ? showTitle.toUpperCase() : title?.toUpperCase()}{" "}
            </div>
            {isChildren &&
              (dropDownOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />)}
          </div>
        </Link>
      )}
      {isChildren && (
        <div
          className={`${
            dropDownOpen ? "  mb-4 h-auto pl-3" : "p-0 h-0"
          }  w-full  overflow-hidden`}
        >
          {children}
        </div>
      )}
    </>
  );
};
